import { column } from "@podtrac/common/grid";
import { DateCell } from "./date-cell";

export const publishedDateColumn = () =>
    column.group({
        header: "Published Date",
        align: "right",
        columns: [
            column.accessor("publicationDate", {
                id: "Published Date",
                header: "",
                cell: DateCell,
                align: "right",
            }),
        ],
    });
